module.exports = __webpack_public_path__ + "static/vivacity-logo-80742815d755d8259a73fbd77e134f5c.png";